import confetti from "canvas-confetti";
import { addElementStyles } from "./helpers";

/*

.confetti-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  margin: auto;
  pointer-events: none;
}

*/

export function playConfetti() {
    const canvasParent = window.document.body;
    const myCanvas = document.createElement('canvas');
    myCanvas.classList.add('goaltracker-confetti-canvas');
    addElementStyles(myCanvas, {
        "position": "fixed",
        "top": "0",
        "left": "0",
        "width": "100%",
        "height": "100%",
        "zIndex": "3000",
        "margin": "auto",
        "pointerEvents": "none"
    });

    canvasParent.appendChild(myCanvas);

    const myConfetti = confetti.create(myCanvas, { resize: true });

    myConfetti({
        particleCount: 220,
        spread: 360,
        startVelocity: 40,
        angle: 0,
        origin: {
            y: 0.3
        },
        colors: [
            '#ff6b00',
            '#fdd25f',
            '#9054a1',
            '#46bb95',
            '#00acca',
            '#e54f5e'
        ],
        scalar: 1.2,
        ticks: 200,
    });

    myConfetti({
        particleCount: 100,
        spread: 180,
        startVelocity: 20,
        angle: 90,
        origin: {
            y: 0.3
        },
        colors: [
            '#ff6b00',
            '#fdd25f',
            '#9054a1',
            '#46bb95',
            '#00acca',
            '#e54f5e'
        ],
        scalar: 1.2,
        ticks: 200,
    });

    myConfetti({
        particleCount: 100,
        spread: 180,
        startVelocity: 20,
        angle: 270,
        origin: {
            y: 0.2
        },
        colors: [
            '#ff6b00',
            '#fdd25f',
            '#9054a1',
            '#46bb95',
            '#00acca',
            '#e54f5e'
        ],
        scalar: 1.2,
        ticks: 200,
    });

    setTimeout(() => {
        myConfetti.reset();
    }, 15000);
}